import React, { useState, useEffect, useRef } from 'react';
import { startOfWeek, endOfWeek, isWithinInterval, format } from 'date-fns';
import { pt } from 'date-fns/locale';
import NavBar from '../../../../components/NavBarAdmin';
import VenuesApprovalRequests from '../Venues/VenuesApprovalRequests';
import { Puff } from 'react-loading-icons';
import html2canvas from 'html2canvas';

const StoriesGenerator = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const storyRef = useRef(null);

    useEffect(() => {
        fetchEvents();
    }, []);

    const fetchEvents = async () => {
        setLoading(true);
        try {
            const response = await VenuesApprovalRequests.getEventList({});
            if (response && response.status) {
                const allEvents = response.data;
                const now = new Date();
                const start = startOfWeek(now, { weekStartsOn: 1 }); // Monday
                const end = endOfWeek(now, { weekStartsOn: 1 });

                const weeklyEvents = allEvents.filter(event => {
                    if (!event.date) return false;
                    const eventDate = new Date(event.date);
                    return isWithinInterval(eventDate, { start, end });
                });
                setEvents(weeklyEvents);
            }
        } catch (error) {
            console.error("Error fetching events", error);
        } finally {
            setLoading(false);
        }
    };

    const handleGenerateClick = (event) => {
        setSelectedEvent(event);
        // Wait for state to update and render the hidden div
        setTimeout(() => {
            generateImage(event);
        }, 500);
    };

    const generateImage = async (event) => {
        if (!storyRef.current) return;

        try {
            const canvas = await html2canvas(storyRef.current, {
                useCORS: true,
                scale: 1, // 1080x1920 is already large, no need to upscale too much
                backgroundColor: null, // Transparent background if needed, though we set one
            });

            const link = document.createElement('a');
            link.download = `story-${event.name.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.png`;
            link.href = canvas.toDataURL('image/png');
            link.click();

            // Optional: Clear selection after download
            // setSelectedEvent(null); 
        } catch (error) {
            console.error("Error generating image:", error);
            alert("Erro ao gerar imagem. Verifique se a imagem do evento permite CORS.");
        }
    };

    // Helper to capitalize first letter
    const capitalize = (s) => s && s[0].toUpperCase() + s.slice(1);

    return (
        <NavBar>
            <div style={{ padding: '20px' }}>
                <h2 className="mb-4">Gerador de Stories (Esta Semana)</h2>
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                        <Puff stroke="#333" />
                    </div>
                ) : (
                    <div className="row">
                        {events.length === 0 ? (
                            <div className="col-12 text-center">
                                <p>Não há eventos para esta semana.</p>
                            </div>
                        ) : events.map(event => (
                            <div key={event.id} className="col-md-4 col-lg-3 mb-4">
                                <div className="card h-100 shadow-sm">
                                    <div style={{ height: '200px', overflow: 'hidden' }}>
                                        <img src={event.image} className="card-img-top" alt={event.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                    </div>
                                    <div className="card-body d-flex flex-column">
                                        <h5 className="card-title">{event.name}</h5>
                                        <p className="card-text text-muted">
                                            <i className="fa-regular fa-calendar"></i> {format(new Date(event.date), 'dd/MM/yyyy')}
                                        </p>
                                        {event.venue_name && (
                                            <p className="card-text text-muted">
                                                <i className="fa-solid fa-location-dot"></i> {event.venue_name}
                                            </p>
                                        )}
                                        <button className="btn btn-primary mt-auto" onClick={() => handleGenerateClick(event)}>
                                            <i className="fa-solid fa-download"></i> Download Story
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Hidden Story Design Area */}
                {selectedEvent && (
                    <div style={{ position: 'absolute', top: '-10000px', left: '-10000px' }}>
                        <div
                            ref={storyRef}
                            style={{
                                width: '1080px',
                                height: '1920px',
                                background: 'linear-gradient(180deg, #021220 0%, #01080e 100%)', // Deep Blue
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '80px 50px',
                                boxSizing: 'border-box',
                                fontFamily: "'Inter', sans-serif",
                                color: 'white',
                                overflow: 'hidden' // Ensure watermark doesn't overflow
                            }}
                        >
                            {/* Background Watermark */}
                            <div style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '120%',
                                height: 'auto',
                                opacity: '0.03',
                                pointerEvents: 'none',
                                zIndex: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <img src="/img/logo/logo.png" alt="" style={{ width: '100%' }} />
                            </div>

                            {/* 1. Logo Centered at Top */}
                            <div style={{ marginBottom: '60px', width: '100%', display: 'flex', justifyContent: 'center', zIndex: 1 }}>
                                <img
                                    src="/img/logo/logo.png"
                                    alt="Nightspot"
                                    style={{
                                        width: '400px',
                                        height: 'auto',
                                        filter: 'drop-shadow(0 0 10px rgba(255,255,255,0.2))'
                                    }}
                                />
                            </div>

                            {/* 2. Main Image */}
                            <div style={{
                                width: '900px',
                                height: '900px',
                                borderRadius: '50px',
                                overflow: 'hidden',
                                marginBottom: '80px',
                                boxShadow: '0 30px 60px rgba(0,0,0,0.6)',
                                border: '4px solid rgba(255,255,255,0.1)',
                                position: 'relative',
                                zIndex: 1
                            }}>
                                <img
                                    src={selectedEvent.image}
                                    alt={selectedEvent.name}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    crossOrigin="anonymous"
                                />
                            </div>

                            {/* 3. Event Details */}
                            <div style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                width: '100%',
                                textAlign: 'center',
                                zIndex: 1
                            }}>
                                {/* Event Name */}
                                <h1 style={{
                                    fontSize: '90px',
                                    fontWeight: '900',
                                    margin: '0 0 20px 0',
                                    lineHeight: '1.1',
                                    textTransform: 'uppercase',
                                    letterSpacing: '-1px',
                                    textShadow: '0 4px 10px rgba(0,0,0,0.5)'
                                }}>
                                    {selectedEvent.name}
                                </h1>

                                {/* Venue Name - Separated */}
                                {selectedEvent.venue_name && (
                                    <div style={{
                                        fontSize: '50px',
                                        fontWeight: '700',
                                        color: '#cccccc',
                                        marginBottom: '30px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '2px',
                                        borderBottom: '2px solid #333',
                                        paddingBottom: '10px'
                                    }}>
                                        {selectedEvent.venue_name}
                                    </div>
                                )}

                                {/* Date */}
                                <div style={{
                                    fontSize: '60px',
                                    fontWeight: '600',
                                    color: '#ff0055',
                                    marginBottom: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '20px'
                                }}>
                                    <i className="fa-regular fa-calendar" style={{ fontSize: '50px' }}></i>
                                    {capitalize(format(new Date(selectedEvent.date), 'EEEE d MMMM', { locale: pt }))}
                                </div>

                                {/* Location (City/Address if needed, or just keep Venue) */}
                                {/* If venue_name is displayed, we might not need location unless it's the address. 
                                    Let's show location if it's different or just as extra info if available and not same as venue */}
                                {selectedEvent.location && selectedEvent.location !== selectedEvent.venue_name && (
                                    <div style={{
                                        fontSize: '35px',
                                        color: '#888',
                                        marginTop: '10px'
                                    }}>
                                        <i className="fa-solid fa-location-dot"></i> {selectedEvent.location}
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div style={{ marginTop: 'auto', textAlign: 'center', zIndex: 1 }}>
                                <div style={{
                                    fontSize: '30px',
                                    color: '#444',
                                    letterSpacing: '8px',
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase'
                                }}>
                                    nightspotapp.com
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </NavBar>
    );
};

export default StoriesGenerator;
